export enum CustomPDFReportOrientation {
    LANDSCAPE = 'landscape',
    PORTRAIT = 'portrait',
}
